import { DescriptionNote } from '@/screens/Split/page/ui/DescriptionNote'

import { VerticalSection } from '@/shared/ui/VerticalSection'

import { advantages, categoriesListData, decription } from './data'
import { Advantages } from './ui/Advantages'
import { CategoryGrid } from './ui/CategoryGrid'
import { HeroBanner } from './ui/HeroBanner'
import { SplitSteps } from './ui/SplitSteps'
import { SplitWork } from './ui/SplitWork'

import cls from './styles.module.scss'

export const Split = () => (
	<div className={cls.root}>
		<HeroBanner />
		<VerticalSection className={cls.section} title="Покупайте сразу, а оплату делите на части" borderNone>
			<SplitSteps />
		</VerticalSection>
		<VerticalSection className={cls.section} title="Как работает Сплит?" borderNone>
			<SplitWork />
		</VerticalSection>
		<VerticalSection className={cls.section} title="Просто и удобно" borderNone>
			<Advantages items={advantages} />
		</VerticalSection>
		<VerticalSection className={cls.section} title="Выбирайте и покупайте удобно" borderNone>
			<CategoryGrid items={categoriesListData} />
		</VerticalSection>
		<DescriptionNote description={decription} />
	</div>
)
